import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {renderIf, renderMail, renderPhone} from '../../../../Shared'
import {HeaderWithIconLine} from '../../../Templates/items/ListHeader'
import getLabelOfGender from "../../../../../helpers/getLabelOfGender";
import {DatePlaceItem, DoubleValueItem} from "../../../CatholicHousehold/components/CatholicHouseholdComponents";
import {ItemInformation} from "../../../Organization/OrganizationEntity";
import {BsInfoCircleFill} from "react-icons/bs";
import {convertStringToDate} from "../../../../../helpers/dateUtils";

export const StudentInformationCompact = ({student}) => {
    const t = useTranslate()
    const {
        student_idcode,
        prefix_title,
        patron_saint_name,
        fullname,
        gender,
        date_of_birth,
        place_of_birth,
        contact_phone,
        contact_email,
    } = student ?? {}

    return (
        <div className="flex flex-col gap-1 mb-3">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <BsInfoCircleFill size={14} className="text-color-500 mr-1"/>
                        <span className="font-bold text-sm text-color-300 uppercase tracking-wider">
                            {t('student information')}
                        </span>
                    </div>
                )}
            />
            <div className="flex flex-col gap-1 ml-2">
                <ItemInformation
                    primary={true}
                    label="fullname"
                    value={`${prefix_title || patron_saint_name || ''} ${fullname}`}
                    className="text-xs"
                />
                <ItemInformation
                    label="student code"
                    value={student_idcode}
                    className="text-xs italic"
                />
                <ItemInformation className="text-xs italic" label="gender" value={t(getLabelOfGender(gender))}/>
                <DatePlaceItem
                    label="date of birth"
                    date={date_of_birth ? convertStringToDate(date_of_birth).format('DD/MM/YYYY') : t('not update')}
                    place={place_of_birth}
                    className="text-xs italic"
                />
                {renderIf(
                    _.some([contact_phone, contact_email]),
                    <DoubleValueItem
                        labelFirst="contact"
                        valueFirst={renderPhone(contact_phone)}
                        labelSecond={contact_email ? ' - ' : ''}
                        valueSecond={renderMail(contact_email)}
                        className="text-xs italic"
                    />
                )}
            </div>
        </div>
    )
}
